// src/utils/analytics.js
function getGtag() {
  return window.gtag || null;
}

export function gaPageview() {
  const gtag = getGtag();
  if (!gtag) return;
  gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search
  });
}

export function gaEvent(name, params = {}) {
  const gtag = getGtag();
  if (!gtag) return;
  gtag('event', name, params);
}

// Auth Events
export const authEvents = {
  login: (method = 'email') => gaEvent('login', { method }),
  signup: (method = 'email') => gaEvent('sign_up', { method }),
  logout: () => gaEvent('logout'),
};

// Newsletter Events
export const newsletterEvents = {
  subscribe: (source, variant = null) => gaEvent('newsletter_subscribe', { 
    source, 
    ab_test_variant: variant || localStorage.getItem('ab_test_variant')
  }),
  unsubscribe: (reason = 'user_initiated') => gaEvent('newsletter_unsubscribe', { reason }),
  updatePreferences: (changes) => gaEvent('update_preferences', { changes }),
};

// User Interaction Events
export const userEvents = {
  pageView: (pageName, properties = {}) => gaEvent('page_interaction', { page_name: pageName, ...properties }),
  buttonClick: (buttonName, location) => gaEvent('button_click', { button_name: buttonName, location }),
  linkClick: (linkName, destination) => gaEvent('link_click', { link_name: linkName, destination }),
  formSubmit: (formName, success) => gaEvent('form_submit', { form_name: formName, success }),
  error: (errorType, errorMessage) => gaEvent('error_occurred', { error_type: errorType, error_message: errorMessage }),
};